module.exports = __webpack_public_path__ + "static/media/about-kovel-2.9e36262f.mp4";